"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var immutable_1 = require("immutable");
var properties_node_1 = require("./properties-node");
var ControlPropertiesModel = /** @class */ (function (_super) {
    __extends(ControlPropertiesModel, _super);
    function ControlPropertiesModel(id, generalProperties) {
        var _this = _super.call(this, id) || this;
        _this.generalProperties = generalProperties;
        return _this;
    }
    ControlPropertiesModel.createEmpty = function (id) {
        return new ControlPropertiesModel(id, immutable_1.Map());
    };
    ControlPropertiesModel.copyWithNewId = function (newId, controlProperties) {
        return new ControlPropertiesModel(newId, controlProperties.generalProperties);
    };
    ControlPropertiesModel.fromJS = function (controlId, jsObject) {
        return new ControlPropertiesModel(controlId, immutable_1.fromJS(jsObject));
    };
    Object.defineProperty(ControlPropertiesModel.prototype, "generatedId", {
        get: function () {
            return this._generatedId;
        },
        set: function (value) {
            this._generatedId = value;
        },
        enumerable: true,
        configurable: true
    });
    ControlPropertiesModel.prototype.toJS = function () {
        return this.generalProperties.set('controlId', this.id).toJS();
    };
    Object.defineProperty(ControlPropertiesModel.prototype, "idSuffix", {
        get: function () {
            return this.generalProperties &&
                this.generalProperties.has(ControlPropertiesModel.GENERATED_ID_SUFFIX_KEY)
                ? this.generalProperties.get(ControlPropertiesModel.GENERATED_ID_SUFFIX_KEY)
                : '';
        },
        enumerable: true,
        configurable: true
    });
    ControlPropertiesModel.GENERATED_ID_SUFFIX_KEY = 'generatedIdSuffix';
    return ControlPropertiesModel;
}(properties_node_1.PropertiesNode));
exports.ControlPropertiesModel = ControlPropertiesModel;
//# sourceMappingURL=control-properties-model.js.map